module.exports = __webpack_public_path__ + "static/img/WESLEY-WALLEY.3b02080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WESLEY-WALLEY.jpg
// module id = G8Na
// module chunks = 0